var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBackground = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.75,
    height: 51.78,
    viewBox: "0 0 89.75 51.78",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Isometric") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.88,24.17V0h-2V24.17L3,0H0V1.74H0V50.08H0v1.71H3.06L44.88,27.64V51.78h2V27.64L88.69,51.78h1.06V0h-1ZM2,50.08V1.73L43.88,25.91Zm87.74,0L47.88,25.91,89.75,1.73Z",
    fill: "#fff",
    opacity: 0.08
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/background.1468876f792437ff8c92fb3b0eb4f685.svg";